import i18n  from "i18next";
import french from "./french.json";
import english from "./english.json";
import {initReactI18next} from "react-i18next";
import Store from "../Store/configureStore";
import changeTheme from "../Store/Reducers/themeReducer";





function initI18n() {

    const languageDetector = {
        type: 'languageDetector',
        async: true,
        detect: async (callback) => {
            const storedLanguageTag = Store.getState().changeTheme.lang;
            if (storedLanguageTag) {
                return callback(storedLanguageTag);
            }
            /*const action = {'type' :'CHANGE_LANG','value' : 'fr'};
            Store.dispatch(action);
            callback("fr");*/
        },
        init: () => {},
        cacheUserLanguage: () => {},
    };

    i18n.use(languageDetector).use(initReactI18next).init({
        debug:false,
        resources:{
            en:english,
            fr:french
        },
        react:{
            useSuspense:false
        }
    });
}

export default initI18n ;
